import InputElement, {
	IntegerInputElement,
} from "features/forms/components/InputElement";
import { EditableSelectorElement } from "features/forms/components/InputElement";
import React from "react";
import Selector from "../../../inventory/subFeatures/selector/Selector";

const LeadTradeInfo = ({
	currentLead,
	handleChange,
	methods,
	yearList,
	makeList,
	modelList,
}) => {
	console.log(currentLead);
	return (
		<>
			<InputElement
				disableValidation={true}
				value={currentLead?.tradeYear || 0}
				label="Year"
				disable={false}
				name="tradeYear"
				type="number"
				onChange={(e) => handleChange("tradeYear", e.target.value)}
				// options={yearList}
			/>
			<InputElement
				disableValidation={true}
				disable={false}
				label="Make"
				type="text"
				value={currentLead?.tradeMake || ""}
				onChange={(e) => handleChange("tradeMake", e.target.value)}
				// options={makeList}
				name="tradeMake"
			/>
			<InputElement
				disableValidation={true}
				disable={false}
				label="Model"
				type="text"
				value={currentLead?.tradeModel || ""}
				onChange={(e) => handleChange("tradeModel", e.target.value)}
				// options={modelList}
				name="tradeModel"
			/>
			<InputElement
				disableValidation={true}
				value={currentLead?.tradeColor || ""}
				name="tradeColor"
				label="Color"
				type="text"
				onChange={(e) => handleChange("tradeColor", e.target.value)}
			/>
			<InputElement
				disableValidation={true}
				value={currentLead?.tradeTransmission || ""}
				name="tradeTransmission"
				label="Transmission"
				type="text"
				onChange={(e) => {
					handleChange("tradeTransmission", e.target.value);
				}}
			/>
			<InputElement
				disableValidation={true}
				value={currentLead?.tradeVin || ""}
				readOnly={false}
				name="tradeVin"
				label="Vin"
				type="text"
				onChange={(e) => handleChange("tradeVin", e.target.value)}
			/>
			<InputElement
				disableValidation={true}
				value={currentLead?.tradeMileage || 0}
				name="tradeMileage"
				label="Mileage"
				type="number"
				onChange={(e) => handleChange("tradeMileage", e.target.value)}
			/>
			<Selector
				name="tradeCondition"
				selectedOption={currentLead?.tradeVehicleCondition || ""}
				handleChange={(e) => handleChange("tradeVehicleCondition", e)}
				selectType="condition"
				selectLabel="Condition"
			/>
		</>
	);
};

export default LeadTradeInfo;
